import type { NotificationDetail } from 'types/types/notification'

import { captureException } from '@sentry/browser'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { hasFinishedAuthentication } from 'helpers/exchangeToken'
import { fetchAPI } from 'libs/apis'

const ReceivedNotification: React.FC = () => {
  const history = useHistory()
  const params = useParams<{ messageId: string }>()

  useEffect(() => {
    getTicketId(params.messageId)
  }, [])

  const getTicketId = async (messageId: string): Promise<string | void> => {
    if (!hasFinishedAuthentication()) {
      return
    }

    try {
      const { body } = await fetchAPI<NotificationDetail>({
        apiUrl: window._env_.REACT_APP_API_URL,
        method: 'GET',
        path: `/v1/messaging/notification/${messageId}`,
      })

      const ticketId = body.dataBody?.id

      if (ticketId) {
        redirectToTicketDetail(ticketId)
      }
    } catch (error) {
      captureException(error)
    }
  }

  const redirectToTicketDetail = (ticketId: string) => {
    history.push(`/ticket/${ticketId}/detail`)
  }

  return <></>
}

export default ReceivedNotification
